import type { enReplenishment } from '../en/replenishment';

export const idReplenishment: Record<keyof typeof enReplenishment, string> = {
  'stok.replenishment.title': 'Perencanaan pengisian stok',
  'stok.replenishment.subtitle':
    'Perhitungan permintaan, stok tersedia, transfer, dan pembelian yang dapat ditelusuri.',
  'stok.replenishment.empty':
    'Belum ada kebijakan perencanaan. Tambahkan satu untuk barang persediaan.',
  'stok.replenishment.policyTitle': 'Kebijakan perencanaan',
  'stok.replenishment.policyDesc':
    'Atur rentang permintaan, buffer stok, aturan pemasok, dan lokasi penerimaan.',
  'stok.replenishment.chooseItem': 'Pilih barang',
  'stok.replenishment.destination': 'Lokasi tujuan',
  'stok.replenishment.chooseLocation': 'Pilih lokasi',
  'stok.replenishment.supplier': 'Pemasok pilihan',
  'stok.replenishment.noSupplier': 'Tanpa pemasok pilihan',
  'stok.replenishment.horizon': 'Horizon perencanaan (hari)',
  'stok.replenishment.lookback': 'Riwayat permintaan (hari)',
  'stok.replenishment.lead': 'Lead time (hari)',
  'stok.replenishment.safety': 'Safety stock (satuan dasar)',
  'stok.replenishment.moq': 'MOQ (satuan dasar)',
  'stok.replenishment.multiple': 'Kelipatan pesanan (satuan dasar)',
  'stok.replenishment.save': 'Tambah kebijakan',
  'stok.replenishment.saved': 'Kebijakan perencanaan disimpan.',
  'stok.replenishment.actionNeeded': 'Perlu tindakan',
  'stok.replenishment.covered': 'Terpenuhi',
  'stok.replenishment.forecast': 'Prediksi permintaan',
  'stok.replenishment.safetyStock': 'Safety stock',
  'stok.replenishment.onHand': 'Stok fisik',
  'stok.replenishment.blocked': 'Diblokir / kedaluwarsa',
  'stok.replenishment.reserved': 'Direservasi',
  'stok.replenishment.available': 'Stok siap pakai',
  'stok.replenishment.inTransit': 'Dalam perjalanan',
  'stok.replenishment.receipts': 'PO dalam horizon',
  'stok.replenishment.netRequired': 'Kebutuhan bersih',
  'stok.replenishment.formulaNote':
    'Stok siap pakai sudah mengurangi stok terblokir dan reservasi. Penerimaan hanya menghitung PO terbuka yang jatuh tempo dalam {horizon} hari.',
  'stok.replenishment.transferFrom': 'Transfer dari {location}',
  'stok.replenishment.purchase': 'Saran pembelian',
  'stok.replenishment.createTransfer': 'Buat draf transfer',
  'stok.replenishment.createPr': 'Buat draf permintaan',
  'stok.replenishment.noAction': 'Tidak perlu tindakan pengisian stok.',
  'stok.replenishment.openDraft': 'Buka {number}',
  'stok.replenishment.draftCreated': 'Draf {number} dibuat.',
};
